import { render, staticRenderFns } from "./FormActivation.vue?vue&type=template&id=68973718&"
import script from "./FormActivation.vue?vue&type=script&lang=js&"
export * from "./FormActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports